"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const OptionDetail_vue_1 = tslib_1.__importDefault(require("./OptionDetail.vue"));
const locales_1 = tslib_1.__importDefault(require("../render/locales"));
const common_1 = require("../assets/common");
const conf_1 = require("./conf");
const __sfc_main = {};
__sfc_main.props = {
    list: {
        type: Array,
        default: []
    },
    dataList: {
        type: Array,
        default: []
    },
    activeIdx: {
        type: Number,
        default: 0
    },
    rateColorCls: {
        type: String,
        default: ''
    },
    langText: {
        type: String,
        default: ''
    },
    isEn: {
        type: Boolean,
        default: false
    },
    isDlg: {
        type: Boolean,
        default: false
    },
    isPi: {
        type: Boolean,
        default: false
    },
    isNn: {
        type: Boolean,
        default: false
    }
};
__sfc_main.setup = (__props, __ctx) => {
    var _a;
    const { useI18n, useToast, useBehaviour, useUser } = require('@fegobull/webapi').use;
    const $tran = useI18n(locales_1.default);
    const { ftReport } = ((_a = window.FEGORender) === null || _a === void 0 ? void 0 : _a.plugins) || {};
    const showOptionDlg = (0, vue_demi_1.ref)(false);
    const optionDetailTmp = (0, vue_demi_1.ref)(null);
    const stockDetailTmp = (0, vue_demi_1.ref)(null);
    const optionInfoTmp = (0, vue_demi_1.ref)(null);
    const Toast = useToast();
    const TEN_MINUTE = 10;
    const SIZE_UNIT = 1e9;
    const props = __props;
    const { runBehaviour } = useBehaviour();
    const { uid } = useUser();
    const toLogin = () => {
        runBehaviour(null, {
            type: 'login',
            value: location.href,
            withQuery: true
        });
    };
    const toStock = (evt, item) => {
        ftReport === null || ftReport === void 0 ? void 0 : ftReport.record(evt, {
            $element_name: `产品_跳转股票_${item.stockId}`
        });
        if (props.isNn) {
            window.location.href = `futunn://quote/stockDetail/${item.stockId}/1`;
            return;
        }
        window.location.href = `futumm://quote/stockDetail/${item.stockId}/1`;
    };
    const showMore = (evt, item) => {
        ftReport === null || ftReport === void 0 ? void 0 : ftReport.record(evt, {
            $element_name: `产品_查看更多_${item.plateId}`
        });
        if (props.isNn) {
            window.location.href = `futunn://quote/stockDetail/${item.plateId}/1`;
            return;
        }
        window.location.href = `futumm://quote/stockDetail/${item.plateId}/1`;
    };
    const toOption = (evt, item) => {
        ftReport === null || ftReport === void 0 ? void 0 : ftReport.record(evt, {
            $element_name: `产品_跳转期权_${item.optionId}`
        });
        if (props.isNn) {
            window.location.href = `futunn://quote/stockDetailV2?stockID=${item.optionId}`;
            return;
        }
        window.location.href = `futumm://quote/stockDetailV2?stockID=${item.optionId}`;
    };
    const toPiStock = (evt, item) => {
        if (!uid) {
            toLogin();
            return;
        }
        if (!props.isPi && props.isNn) {
            ftReport === null || ftReport === void 0 ? void 0 : ftReport.record(evt, {
                $element_name: `产品_跳转PI`
            });
            window.location.href = 'https://upgrowth.futuhk.com/pi';
        }
        if (props.isNn) {
            window.location.href = `futunn://quote/stockDetail/${item.stockId}/1`;
            return;
        }
        ftReport === null || ftReport === void 0 ? void 0 : ftReport.record(evt, {
            $element_name: `产品_跳转股票_${item.stockId}`
        });
        window.location.href = `futumm://quote/stockDetail/${item.stockId}/1`;
    };
    const showOptionDetail = async (evt, item) => {
        var _a, _b, _c, _d, _e, _f, _g;
        Toast.loading(TEN_MINUTE);
        // ftReport?.record(evt, { $element_name: `产品_跳转股票_${item.stockId}` });
        optionDetailTmp.value = item;
        if (!((_a = stockDetailTmp.value) === null || _a === void 0 ? void 0 : _a[item.stockId])) {
            stockDetailTmp.value = stockDetailTmp.value || {};
            const baseInfo = await (0, common_1.getStockBaseInfo)([item.stockId]);
            const baseTmp = baseInfo[item.stockId] || {};
            stockDetailTmp.value[item.stockId] = {
                srcCode: baseTmp.srcCode
            };
        }
        if (!((_b = optionInfoTmp.value) === null || _b === void 0 ? void 0 : _b[item.optionId])) {
            optionInfoTmp.value = optionInfoTmp.value || {};
            const baseInfo = await (0, common_1.getStockBaseInfo)([item.optionId]);
            const baseTmp = baseInfo[item.optionId] || {};
            optionInfoTmp.value[item.optionId] = {
                optionCode: (_c = baseTmp === null || baseTmp === void 0 ? void 0 : baseTmp.optionInfo) === null || _c === void 0 ? void 0 : _c.optionCode,
                shareSize: (_d = baseTmp === null || baseTmp === void 0 ? void 0 : baseTmp.optionInfo) === null || _d === void 0 ? void 0 : _d.shareSize
            };
        }
        optionDetailTmp.value.srcCode = (_e = stockDetailTmp.value[item.stockId]) === null || _e === void 0 ? void 0 : _e.srcCode;
        optionDetailTmp.value.shareSize = ((_f = optionInfoTmp.value[item.optionId]) === null || _f === void 0 ? void 0 : _f.shareSize) / SIZE_UNIT;
        optionDetailTmp.value.optionCode = (_g = optionInfoTmp.value[item.optionId]) === null || _g === void 0 ? void 0 : _g.optionCode;
        Toast.close();
        showOptionDlg.value = true;
    };
    const closeOptionDlg = () => {
        showOptionDlg.value = false;
    };
    const getStockShowLabel = item => {
        if ((item === null || item === void 0 ? void 0 : item.showType) === conf_1.SHOW_TYPE.NAME) {
            return item.name;
        }
        return item.srcCode;
    };
    return {
        $tran,
        showOptionDlg,
        optionDetailTmp,
        toStock,
        showMore,
        toOption,
        toPiStock,
        showOptionDetail,
        closeOptionDlg,
        getStockShowLabel
    };
};
__sfc_main.components = Object.assign({
    OptionDetail: OptionDetail_vue_1.default
}, __sfc_main.components);
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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